"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var filter_1 = __importDefault(require("lodash/filter"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
function dcStudentFooterNavController(NavigationHistoryService, $window, UserService, VueStoreFactory) {
    var vm = this;
    vm.student = UserService.getCurrentUser();
    vm.studentCanSchedule = true;
    (0, filter_1.default)(VueStoreFactory.state.auth.policies.policies, function (policy, key) {
        return key === "drives";
    }).forEach(function (drives) {
        if (drives.policymeta.hasOwnProperty("allow_students_to_schedule") &&
            !(0, isEmpty_1.default)(drives.policymeta.allow_students_to_schedule)) {
            vm.studentCanSchedule = drives.policymeta.allow_students_to_schedule == 1;
        }
    });
    vm.columnClass =
        vm.student.status === "Active" && vm.studentCanSchedule === true
            ? "col-xs-5"
            : "col-xs-6";
    vm.navBack = function () {
        if (NavigationHistoryService.getHistory().length > 1) {
            $window.history.back();
        }
    };
}
dcStudentFooterNavController.$inject = [
    "NavigationHistoryService",
    "$window",
    "UserService",
    "VueStoreFactory",
];
exports.default = dcStudentFooterNavController;
